/*角色 */
import { $http, buildHeaders } from "./index";

//获取列表
export const adminRole_page = (params) => {
  return $http.get("/admin/AdminRole/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const adminRole_detail = (id) => {
  return $http.get("/admin/AdminRole/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const adminRole_add = (data) => {
  return $http.post("/admin/AdminRole/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const adminRole_edit = (data) => {
  return $http.post("/admin/AdminRole/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const adminRole_delete = (id) => {
  return $http.post(
    "/admin/AdminRole/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//修改状态
export const adminRole_updateStatus = (data) => {
  return $http.post("/admin/AdminRole/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//角色授权
export const adminRole_auth = (data) => {
  return $http.post("/admin/AdminRole/auth", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//绑定用户
export const adminRole_bindAdmin = (data) => {
  return $http.post("/admin/AdminRole/bindAdmin", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
